import { getCashAvailableFactors } from 'api/v2/transactions/cashAvailable';
import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import useFeatureLock from 'hooks/Subscriptions/useFeatureLock';
import { useQuery } from 'react-query';
import { BankTransactionsCacheKeys } from 'types/cacheKeys.types';
import { SubscriptionLockKeysEnum } from 'types/subscriptions.types';
import type { CashAvailableFactorsType } from 'types/transactions.types';

const useCachAvailable = () => {
  const { data: user } = useGetCurrentCustomerData();

  const { isFeatureLocked } = useFeatureLock();

  return useQuery<CashAvailableFactorsType>(
    [BankTransactionsCacheKeys.CashAvailableFactors],
    getCashAvailableFactors,
    {
      enabled:
        !!user?._id &&
        !isFeatureLocked(SubscriptionLockKeysEnum.viewCashAvailable),
    },
  );
};

export default useCachAvailable;
